import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ReplayParser } from "@lib/titan2-slingo/dist/api/replay/ReplayParser";
export class GameReplayParser extends ReplayParser {
    parseSpinResultData(spinResultsData, sharedData) {
        return spinResultsData?.map(uniqueData => {
            const spinData = this.cloneData(sharedData);
            const spinResultData = uniqueData.getDataObject(SlingoConstants.PROPERTY_SPIN_RESULT);
            const gameProgressData = uniqueData.getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS);
            const actionsData = uniqueData.getDataObject(SlingoConstants.PROPERTY_ACTIONS);
            spinData.putPlainObject(SlingoConstants.PROPERTY_SPIN_RESULT, spinResultData.toObject());
            spinData.putPlainObject(SlingoConstants.PROPERTY_GAME_PROGRESS, gameProgressData.toObject());
            spinData.putPlainObject(SlingoConstants.PROPERTY_ACTIONS, actionsData.toObject());
            spinData.putString(SlingoConstants.PROPERTY_STATE, uniqueData.getString(SlingoConstants.PROPERTY_STATE));
            this.additionalUniqueSpinProperties.forEach(property => {
                if (uniqueData.containsKey(property)) {
                    uniqueData.putPlainObject(property, uniqueData.getDataObject(property).toObject());
                }
            });
            return spinData;
        });
    }
    getTotalSpinCount(spinResultsData) {
        return spinResultsData
            .getDataObject(SlingoConstants.PROPERTY_CONFIG)
            .getDataObject(SlingoConstants.PROPERTY_GAME_CONFIG)
            .getNumber(SlingoConstants.PROPERTY_STANDARD_SPINS);
    }
}
//# sourceMappingURL=GameReplayParser.js.map